export function passwordValidation(password, username) {
  if (!password) {
    return Promise.reject('Please enter the new password.');
  }

  if (password.length < 6) {
    return Promise.reject('Password must be at least 6 characters.');
  }

  if (password.length > 14) {
    return Promise.reject("Password can't exceed 14 characters.");
  }

  if (password.toLowerCase().includes(username.toLowerCase())) {
    return Promise.reject("Password can't contain the username.");
  }

  const pattern =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?]).+$/;

  if (!pattern.test(password)) {
    return Promise.reject(
      'Password must contain at least one uppercase letter, one number, and one special character.',
    );
  }

  return Promise.resolve();
}
export function changepasswordValidation(password) {
  if (!password) {
    return Promise.reject('Please enter the new password.');
  }

  if (password.length < 6) {
    return Promise.reject('Password must be at least 6 characters.');
  }

  if (password.length > 14) {
    return Promise.reject("Password can't exceed 14 characters.");
  }

  const pattern =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?]).+$/;

  if (!pattern.test(password)) {
    return Promise.reject(
      'Password must contain at least one uppercase letter, one number, and one special character.',
    );
  }

  return Promise.resolve();
}
